"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TIMEZONE = exports.GUESS_TIMEZONE = exports.DEFAULT_TIMEZONE_TITLE = exports.DEFAULT_TIMEZONE_NAME = exports.UTC_ZONE = void 0;

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var UTC_ZONE = 'UTC';
exports.UTC_ZONE = UTC_ZONE;
var DEFAULT_TIMEZONE_NAME = 'America/New_York';
exports.DEFAULT_TIMEZONE_NAME = DEFAULT_TIMEZONE_NAME;
var DEFAULT_TIMEZONE_TITLE = 'US/Eastern';
exports.DEFAULT_TIMEZONE_TITLE = DEFAULT_TIMEZONE_TITLE;

var GUESS_TIMEZONE = _momentTimezone.default.tz.guess();

exports.GUESS_TIMEZONE = GUESS_TIMEZONE;
var DEFAULT_TIMEZONE = {
  name: DEFAULT_TIMEZONE_NAME,
  title: DEFAULT_TIMEZONE_TITLE,
  abbr: 'ET'
};
exports.DEFAULT_TIMEZONE = DEFAULT_TIMEZONE;